<div class="picker" role="group" [attr.aria-labelledby]="titleId">
  <div class="picker__header">
    <span class="picker__title" [id]="titleId">{{ title }}</span>
    <button type="button" class="picker__close" [attr.aria-label]="'Close ' + title" (click)="closed.emit()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>

  @if (mode === 'image') {
    <label class="ut-btn ut-btn--secondary ut-btn--sm picker__upload" [class.picker__upload--busy]="busy()">
      <span class="material-icons" aria-hidden="true">file_upload</span>
      Upload a file
      <input type="file" accept="image/*" class="sr-only" [disabled]="busy()" (change)="upload($any($event.target))" />
    </label>
    <span class="picker__or">or</span>
  }

  <form class="picker__url" (ngSubmit)="insertUrl()">
    <label class="picker__label" [for]="inputId">{{ mode === 'image' ? 'Image URL' : 'Video URL' }}</label>
    <div class="picker__url-row">
      <input
        type="url"
        class="picker__input"
        name="attachmentUrl"
        placeholder="https://"
        [id]="inputId"
        [class.is-invalid]="!!error()"
        [attr.aria-invalid]="!!error()"
        [attr.aria-describedby]="error() ? errorId : null"
        [(ngModel)]="url"
        (ngModelChange)="error.set('')" />
      <button type="submit" class="ut-btn ut-btn--sm" [disabled]="busy() || !url.trim()">Insert</button>
    </div>
  </form>

  <!-- Stays until the URL changes or the picker closes, instead of a toast that fades. -->
  @if (error()) {
    <p class="picker__error" role="alert" [id]="errorId">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      {{ error() }}
    </p>
  }
</div>
